<template>
  <section>
    <h1>Editar Notificación</h1>
    <hr/><br/>

    <form @submit.prevent="submit">
      <div class="mb-3">
        <label for="name" class="form-label">Nombre de la Notificación:</label>
        <input type="text" name="name" v-model="form.name" class="form-control" />
        <div v-if="errors.name" class="error">{{ errors.name }}</div>
      </div>
      <div class="mb-3">
        <label for="description" class="form-label">Descripción:</label>
        <textarea
          name="description"
          v-model="form.description"
          class="form-control"
        ></textarea>
        <div v-if="errors.description" class="error">{{ errors.description }}</div>
      </div>
      <div class="mb-3">
        <label for="scheduled_time" class="form-label">Hora Programada:</label>
        <input type="time" name="scheduled_time" v-model="form.scheduled_time" class="form-control" />
        <div v-if="errors.scheduled_time" class="error">{{ errors.scheduled_time }}</div>
      </div>
      <button type="submit" class="btn btn-primary">Guardar</button>
      <router-link :to="{name: 'Notifications', params: {id: this.proceeding_id}}" class="btn btn-secondary">Cancelar</router-link>

    </form>
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'EditNotificationView',
  props: ['id','proceeding_id'],
  data() {
    return {
      form: {
        name: '',
        description: '',
        scheduled_time: ''
      },
      errors: {}
    };
  },
  computed: {
    ...mapGetters({ notification: 'stateNotification'}),
  },
  created() {
    this.GetNotification();
  },
  methods: {
    ...mapActions(['updateNotification','viewNotification']),
    async submit() {
        
        this.form.scheduled_time = this.form.scheduled_time + ':00-0600';
        let notification = {
            id: this.id,
            form: this.form,

        };
      try {
        await this.updateNotification(notification);
        this.$router.push({name: 'Notifications', params: {id: this.proceeding_id}});

    } catch (error) {
        this.$toast.error('Error al actualizar la notificación');
        console.log(error);
      }
    },
    async GetNotification() {
        try {
            await this.viewNotification(this.id);
            this.notification.scheduled_time = this.notification.scheduled_time.slice(0, 5);
            this.form = { ...this.notification };
        } catch (error) {
            console.error(error);
            this.$router.push('/notifications/'+this.proceeding_id);
        }
    }
  }
});
</script>